import { create } from 'zustand';

export type FileGalleryObject = {
  get: string | null;
  name: string | null;
  /** Shown as a caption under the file. */
  title?: string | null;
  description?: string | null;
};

type FileGalleryState = {
  files: Array<FileGalleryObject>;
  startIndex: number;
};

type FileGalleryStore = {
  gallery: FileGalleryState | null;
  index: number;
};

const useFileGalleryStore = create<FileGalleryStore>(() => ({
  gallery: null,
  index: 0,
}));

export function useFileGallery() {
  return useFileGalleryStore((state) => state.gallery);
}

export function useFileGalleryIndex() {
  return useFileGalleryStore((state) => state.index);
}

export function setFileGalleryIndex(index: number) {
  useFileGalleryStore.setState({ index });
}

export type OpenFilesInGalleryProps = {
  files: Array<FileGalleryObject>;
  index: number;
};

export function openFilesInGallery(args: OpenFilesInGalleryProps) {
  useFileGalleryStore.setState({
    index: args.index,
    gallery: { files: args.files, startIndex: args.index },
  });
}

export function closeFileGallery() {
  useFileGalleryStore.setState({ gallery: null });
}
